import React from 'react';
import '../styles/Footer.css';

const Footer = () => {
    return (
        <footer >
            <div className="footer-bottom">
                3BoltCourt Chambers &copy; {new Date().getFullYear()} | All Rights Reserved
            </div>
        </footer>
    );
};

export default Footer;
